import { useTranslation } from 'react-i18next';
import { FoldVertical, UnfoldVertical } from 'lucide-react';
import { OVERLAY_ATTRIBUTE } from '../board-grid/useZoomPan';
import { PhotoOverlayButton } from '../photo-editor/PhotoOverlayTools';
import type { PhotoExpansion } from './useExpandablePhoto';

/**
 * Opening a landscape picture out to the height of the screen, and folding it
 * back — bottom-right of the picture (see `useExpandablePhoto`).
 *
 * The corner opposite the zoom's way out, which it keeps company with: both are
 * about how much of the wall is on screen, not about what is drawn on it. The
 * bar along the bottom is padded clear of both corners (`DockedBar`).
 */
export function PhotoExpandButton({ expansion }: { expansion: PhotoExpansion }) {
  const { t } = useTranslation();

  return (
    <div
      className="absolute bottom-2 right-2"
      // Sat on the picture, not in it: the gesture that moved the photo has no
      // claim on this click, and the surface underneath hit-tests presses.
      {...{ [OVERLAY_ATTRIBUTE]: '' }}
      onPointerDown={(event) => event.stopPropagation()}
    >
      <PhotoOverlayButton
        label={t('climbEditor.photo.expand')}
        onClick={expansion.toggle}
        pressed={expansion.expanded}
      >
        {expansion.expanded ? (
          <FoldVertical className="size-4" aria-hidden />
        ) : (
          <UnfoldVertical className="size-4" aria-hidden />
        )}
      </PhotoOverlayButton>
    </div>
  );
}
